import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const agreeToTerms = (control: FormControl) => {
    if (!control.value) {
        return { agreeToTerms: messages.validation.agreeToTerms };
    }
};
